export class AddUser {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(user) {
        console.log("repository", user)
      return await this.userRepository.addUser(user);
    }
  }